import React from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import PublishedTrainingsTab from './components/PublishedTrainingsTab';
import RequestedTrainingsTab from './components/RequestedTrainingsTab';
import AllRequestsTab from './components/AllRequestsTab';
import { useLanguage } from '../../../contexts/LanguageContext';

/**
 * Eğitim Talebi (LmsCreateRequest) ana sayfası — iki sekmeli: "Yayınlanan Eğitimler" (zaten
 * planlanmış/yayınlanmış bir eğitime katılım talebi) ve "Talep Edilen Eğitimler" (henüz
 * planlanmamış bir eğitim için serbest talep). Bkz. docs/lms-create-request.md,
 * docs/LMS-Egitim-Talebi-BE-Istek-Notu.md ve docs/LMS-Egitim-Talebi-Yayinlanan-Egitimler-Roadmap.md.
 *
 * Her sekmenin kendi liste/filtre/form durumu var (bkz. `PublishedTrainingsTab.jsx` /
 * `RequestedTrainingsTab.jsx`) — bu dosya yalnızca sekme kabuğudur, iş mantığı taşımaz.
 *
 * 3. sekme "Tüm Talepler" (`AllRequestsTab.jsx`) — onay akışı (bkz.
 * docs/talep_olustur_onay_akısı.md): her iki türdeki (Yayınlanan/Talep Edilen) tüm kayıtları
 * statüsüyle birlikte listeler, statü geçişlerini (Onaya Gönder/Kabul/Red/İade) ve yorum
 * geçmişini yönetir. İlk iki sekmeye ve bileşenlerine HİÇBİR şey eklenmedi/çıkarılmadı —
 * tamamen ayrı, kendi kendine yeten bir ekran.
 */
const TrainingRequestPage = () => {
    const { th } = useLanguage();

    return (
        <div className="card">
            <h1 className="mb-4">{th('trainingRequest.title')}</h1>

            <TabView>
                <TabPanel header={th('trainingRequest.tabs.published')}>
                    <PublishedTrainingsTab />
                </TabPanel>
                <TabPanel header={th('trainingRequest.tabs.requested')}>
                    <RequestedTrainingsTab />
                </TabPanel>
                <TabPanel header={th('trainingRequest.tabs.all')}>
                    <AllRequestsTab />
                </TabPanel>
            </TabView>
        </div>
    );
};

export default TrainingRequestPage;
